const getTagColor = (value) => {
  if (value >= 0 && value <= 40) {
    return "#dc3333";
  } else if (value > 40 && value <= 99) {
    return "#fbbd14";
  } else {
    return "#04bf04";
  }
};
export default getTagColor;
